export var EQuoteRoutes;
(function (EQuoteRoutes) {
    EQuoteRoutes["EQUITY"] = "/quotes/equity";
    EQuoteRoutes["FUTURE_INDEX"] = "/quotes/futures/index";
    EQuoteRoutes["FUTURE_STOCK"] = "/quotes/futures/stock";
    EQuoteRoutes["OPTION_INDEX"] = "/quotes/options/index";
    EQuoteRoutes["OPTION_STOCK"] = "/quotes/options/stock";
    EQuoteRoutes["INDICES"] = "/quotes/indices";
    EQuoteRoutes["ETF"] = "/quotes/etf";
    EQuoteRoutes["NCD"] = "/quotes/ncd";
})(EQuoteRoutes || (EQuoteRoutes = {}));
export var EQuoteTypes;
(function (EQuoteTypes) {
    EQuoteTypes["FUTIDX"] = "FUTIDX";
    EQuoteTypes["FUTSTK"] = "FUTSTK";
    EQuoteTypes["OPTIDX"] = "OPTIDX";
    EQuoteTypes["OPTSTK"] = "OPTSTK";
    EQuoteTypes["EQUITY"] = "EQUITY";
    EQuoteTypes["INDEX"] = "INDEX";
    EQuoteTypes["NCD"] = "NCD";
})(EQuoteTypes || (EQuoteTypes = {}));
export var quoteRoutes = [
    { type: EQuoteTypes.FUTIDX, route: EQuoteRoutes.FUTURE_INDEX },
    { type: EQuoteTypes.FUTSTK, route: EQuoteRoutes.FUTURE_STOCK },
    { type: EQuoteTypes.INDEX, route: EQuoteRoutes.INDICES },
    { type: EQuoteTypes.OPTIDX, route: EQuoteRoutes.OPTION_INDEX },
    { type: EQuoteTypes.OPTSTK, route: EQuoteRoutes.OPTION_STOCK },
    { type: EQuoteTypes.EQUITY, route: EQuoteRoutes.EQUITY },
    { type: EQuoteTypes.NCD, route: EQuoteRoutes.NCD },
];
export var paths = [
    "path1",
    "path2",
    "path3",
    "path4",
    "path5",
    "path6",
    "path7",
    "path8",
    "path9",
    "path10",
    "path11",
    "path12",
    "path13",
    "path14",
    "path15",
    "path16",
    "path17",
    "path18",
    "path19",
    "path20",
    "path21",
];
export var quotesConstant = {
    quotes: "/quotes",
};
export var quotesRoutes = {
    QIndices: quotesConstant.quotes + "/indices",
    QEtf: quotesConstant.quotes + "/etf",
    QEtfNAV_History: quotesConstant.quotes + "/etf/NavHistory/:schemeCode/:exchange",
    QEquity: quotesConstant.quotes + "/equity",
    QEquity_PEER_Compare: quotesConstant.quotes + "/equity/peer-comparison",
    QOptions_Index: quotesConstant.quotes + "/options/index",
    QOptions_Stock: quotesConstant.quotes + "/options/stock",
    QFutures_Index: quotesConstant.quotes + "/futures/index",
    QFutures_Stock: quotesConstant.quotes + "/futures/stock",
    QMutual_Funds: quotesConstant.quotes + "/mutualfunds",
    QMutual_Funds_STK_Compare: quotesConstant.quotes + "/mutualfunds/:schemeCode/stock-composition",
    QIndex_Funds_STK_Compare: quotesConstant.quotes + "/index/:schemeCode/stock-composition",
    QETF_Funds_STK_Compare: quotesConstant.quotes + "/etf/:schemeCode/:exchange/stock-composition",
    QMutual_Funds_PEER_Compare: quotesConstant.quotes + "/mutualfunds/peer-comparison",
    Q_PEER_Compare: quotesConstant.quotes + "/peer-comparison",
    Q_RM_PEER_Compare: "quotes/rm-quotes/peer-comparison",
    QMF_NAV_History: quotesConstant.quotes + "/mutualfunds/NavHistory/:schemeCode",
    QIndices_STK_Compare: quotesConstant.quotes + "/indices/stock-composition",
    QIndices_STK_Scan: quotesConstant.quotes + "/indices/stock-scan",
    Quotes_INDEX_Const: quotesConstant.quotes + "/index-constituents",
    QIndex: quotesConstant.quotes + "/index",
    QIndex_NAV_History: quotesConstant.quotes + "/index/NavHistory/:schemeCode",
    QNFO: quotesConstant.quotes + "/nfo",
    QPrimary_M_NCD_IPO: quotesConstant.quotes + "/primary-market/ncd-ipo",
    Financial_Analysis: "/financial-analysis",
    QQuotes_M_NCD_IPO: quotesConstant.quotes + "/ncd-ipo",
    QQuotes_IPO: quotesConstant.quotes + "/ipo",
    QQuotes_M_NCD: quotesConstant.quotes + "/ncd/:coCode/:srNo/:code/:exc",
};
var indicesViewAllConstant = {
    indices_Viewall: quotesRoutes.QIndices + "/viewall",
};
export var QIndicesViewAllRoutes = {
    Advances_Declines: indicesViewAllConstant.indices_Viewall + "/advances-declines",
    Insider: indicesViewAllConstant.indices_Viewall + "/insider",
    FII_DII: indicesViewAllConstant.indices_Viewall + "/fiidii",
    Top_Losers: indicesViewAllConstant.indices_Viewall + "/top-losers",
    Top_Gainers: indicesViewAllConstant.indices_Viewall + "/top-gainers",
    Index_Pullers: indicesViewAllConstant.indices_Viewall + "/index-pullers",
    Index_Draggers: indicesViewAllConstant.indices_Viewall + "/index-draggers",
    All_Time_High: indicesViewAllConstant.indices_Viewall + "/alltime-high",
    All_Time_Low: indicesViewAllConstant.indices_Viewall + "/alltime-low",
    Recommendations: indicesViewAllConstant.indices_Viewall + "/recommendations",
    Week_High: indicesViewAllConstant.indices_Viewall + "/week-high",
    Week_Low: indicesViewAllConstant.indices_Viewall + "/week-low",
    Price_Buzzers: indicesViewAllConstant.indices_Viewall + "/price-buzzers",
    Volume_Buzzers: indicesViewAllConstant.indices_Viewall + "/volume-buzzers",
    Upper_Circuit: indicesViewAllConstant.indices_Viewall + "/upper-circuit",
    Lower_Circuit: indicesViewAllConstant.indices_Viewall + "/lower-circuit",
    Out_Performers: indicesViewAllConstant.indices_Viewall + "/outperformers",
    Under_Performers: indicesViewAllConstant.indices_Viewall + "/underperformers",
    MostActive_Volume: indicesViewAllConstant.indices_Viewall + "/active-volume",
    MostActive_Value: indicesViewAllConstant.indices_Viewall + "/active-value",
};
export var quotesIndicesRoutes = [
    { title: "Top Losers", link: QIndicesViewAllRoutes.Top_Losers },
    { title: "Top Gainers", link: QIndicesViewAllRoutes.Top_Gainers },
    { title: "Index Pullers", link: QIndicesViewAllRoutes.Index_Pullers },
    { title: "Index Draggers", link: QIndicesViewAllRoutes.Index_Draggers },
    { title: "All Time High", link: QIndicesViewAllRoutes.All_Time_High },
    { title: "All Time Low", link: QIndicesViewAllRoutes.All_Time_Low },
    { title: "52 Week High", link: QIndicesViewAllRoutes.Week_High },
    { title: "52 Week Low", link: QIndicesViewAllRoutes.Week_Low },
    { title: "Price Buzzers", link: QIndicesViewAllRoutes.Price_Buzzers },
    { title: "Volume Buzzers", link: QIndicesViewAllRoutes.Volume_Buzzers },
    { title: "Upper Circuit", link: QIndicesViewAllRoutes.Upper_Circuit },
    { title: "Lower Circuit", link: QIndicesViewAllRoutes.Lower_Circuit },
    { title: "Out Performers", link: QIndicesViewAllRoutes.Out_Performers },
    { title: "Underperformers", link: QIndicesViewAllRoutes.Under_Performers },
    { title: "Active Volume", link: QIndicesViewAllRoutes.MostActive_Volume },
    { title: "Active Value", link: QIndicesViewAllRoutes.MostActive_Value },
];
export var quotesDrivingSectionLinks = {
    "Top Losers": "quotes/indices" + "?sectionName=top_losers",
    "Top Gainers": "quotes/indices?sectionName=top_gainers",
    "Index Pullers": "quotes/indices?sectionName=index_pullers",
    "Index Draggers": "quotes/indices?sectionName=index_draggers",
    "All Time High": "quotes/indices?sectionName=alltime_high",
    "All Time Low": "quotes/indices?sectionName=alltime_low",
    "52 Week High": "quotes/indices?sectionName=week_high",
    "52 Week Low": "quotes/indices?sectionName=week_low",
    "Price Buzzers": "quotes/indices?sectionName=price_buzzers",
    "Volume Buzzers": "quotes/indices?sectionName=volume_buzzers",
    "Upper Circuit": "quotes/indices?sectionName=upper_circuit",
    "Lower Circuit": "quotes/indices?sectionName=lower_circuit",
    "Out Performers": "quotes/indices?sectionName=outer_performers",
    Underperformers: "quotes/indices?sectionName=under_performers",
    "Active Volume": "quotes/indices?sectionName=active_value",
    "Active Value": "quotes/indices?sectionName=active_volume",
};
export var quotesHeadingRoutes = [
    {
        heading: "Indices",
        link: quotesRoutes.QIndices,
        list: quotesIndicesRoutes,
    },
];
export var QuotesTabsConstants = {
    Indices: "indices",
};
export var quoteTabs = [QuotesTabsConstants.Indices];
// export const quoteSectionLinks = {
//   //-----------------INDICES  WDTM --------------------------
//   // "Top Losers": "markets/equity?sectionName=top_losers",
//   // "Top Gainers": "markets/equity?sectionName=top_gainers",
//   "Index Pullers": "markets/equity?sectionName=index_pullers",
//   "Index Draggers": "markets/equity?sectionName=index_draggers",
//   "All Time High": "markets/equity?sectionName=alltime_high",
//   "All Time Low": "markets/equity?sectionName=alltime_low",
//   "52 Week High": "markets/equity?sectionName=week_high",
//   "52 Week Low": "markets/equity?sectionName=week_low",
//   "Price Buzzers": "markets/equity?sectionName=price_buzzers",
//   "Volume Buzzers": "markets/equity?sectionName=volume_buzzers",
//   "Upper Circuit": "markets/equity?sectionName=upper_circuit",
//   "Lower Circuit": "markets/equity?sectionName=lower_circuit",
//   "Out Performers": "markets/equity?sectionName=outer_performers",
//   Underperformers: "markets/equity?sectionName=under_performers",
//   "Stocks Under Surveillance":
//     "markets/equity?sectionName=stocksUnderSurveillanceWrap",
//   "Indices High/Low": "markets/equity?sectionName=indices",
//   "Market Map": "markets/equity?sectionName=marketmap",
// };
